import clsx from "clsx";
import { ReactNode } from "react";

export function Skeleton(props: { children: ReactNode; loading: boolean; className?: string }) {
  const { children, loading, className = "h-10 w-full" } = props;

  if (!loading) {
    return children;
  }

  return (
    <div className="animate-pulse">
      <div className={clsx("bg-border3", className)}></div>
    </div>
  );
}
